export default __webpack_public_path__ + "static/media/member_tab_icon_white.fb12d058.svg";